export class QuotationType {
  static get TypeNewInstall () {
    return 1
  }
  static get TypeRemoveCar () {
    return 2
  }
  static get TypeReturnCar () {
    return 3
  }
  static get TypeRepair () {
    return 4
  }
  static get TypeMonth () {
    return 5
  }
  static get TypeOffset () {
    return 6
  }
  static get TypeMove () {
    return 7
  }
  static get TypeProject () {
    return 8
  }
  static get TypeTryInstall () {
    return 9
  }
  static get TypeRenew () {
    return 10
  }
  static get TypeProjectPayItem () {
    return 11
  }

  static getQuotationTypeName (QuotationType) {
    let tmpType = parseInt(QuotationType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '新裝機'
        break
      case 2:
        name = '拆機'
        break
      case 3:
        name = '回裝機'
        break
      case 4:
        name = '維修'
        break
      case 5:
        name = '月租'
        break
      case 6:
        name = '補單'
        break
      case 7:
        name = '移機'
        break
      case 8:
        name = '專案'
        break
      case 9:
        name = '試裝'
        break
      case 10:
        name = '續約'
        break
      case 11:
        name = '軟體開發'
        break
    }
    return name
  }
}
